// extracted by mini-css-extract-plugin
export var bubble = "_4e-0";
export var container = "_4e-f";
export var contrastBorder = "_4e-g";
export var greyOut = "_4e-2";
export var initialsColor0 = "_4e-3";
export var initialsColor1 = "_4e-4";
export var initialsColor10 = "_4e-d";
export var initialsColor11 = "_4e-e";
export var initialsColor2 = "_4e-5";
export var initialsColor3 = "_4e-6";
export var initialsColor4 = "_4e-7";
export var initialsColor5 = "_4e-8";
export var initialsColor6 = "_4e-9";
export var initialsColor7 = "_4e-a";
export var initialsColor8 = "_4e-b";
export var initialsColor9 = "_4e-c";
export var initialsWrapper = "_4e-1";
export var large = "_4e-l";
export var medium = "_4e-k";
export var mediumSmall = "_4e-j";
export var mediumSmallMedium = "_4e-o";
export var micro = "_4e-h";
export var small = "_4e-i";
export var tiny = "_4e-n";
export var xTiny = "_4e-m";